// Shown when the player's locally-cached content has been evicted —
// either because the TTL (Screen.cache_ttl_hours, default 168h) elapsed
// without a successful /content fetch, or because an operator hit Force
// Disconnect from the dashboard.
//
// Distinct from ErrorScreen: this is not a hard failure, it's a deliberate
// "stop showing stale content" state. We keep polling in the background
// (the refresh loop + heartbeat are still running), so once the device
// reaches the backend again, fresh content arrives and the App swaps
// back to ContentDisplay automatically.

export default function CacheExpiredScreen() {
  return (
    <div className="flex w-full max-w-md flex-col items-center gap-4 text-center px-5 sm:px-10">
      <h2 className="text-white text-[clamp(1.25rem,6vw,1.5rem)] font-semibold">Lost connection to WeTook</h2>
      <p className="text-muted text-sm leading-relaxed">
        Cached content has been cleared. The screen will return automatically when the connection is restored.
      </p>
    </div>
  )
}
